import { TZDate } from '@date-fns/tz'

export const createNewGermanDate = (): Date => {
  return TZDate.tz('Europe/Berlin')
}
